export default __webpack_public_path__ + "static/media/@zarablockchain.1fbeb695.jpeg";